// @wc-ignore-file
import type { Project } from "@shared/types/supabase.types";

/**
 * CR-39: per-project feature-visibility toggles.
 *
 * Each flag lives on the project container (see migration
 * 20260721120000_add_project_feature_toggles_to_containers.sql). Disabling a
 * feature makes it unavailable in the sidebar, unreachable by direct URL, and
 * invisible to the AI assistant (MCP) — but never deletes data.
 */
export type ProjectFeatureFlag =
  | "show_change_requests"
  | "show_team_messages"
  | "show_ai_chats"
  | "show_tasks";

export const PROJECT_FEATURE_FLAGS: ProjectFeatureFlag[] = [
  "show_change_requests",
  "show_team_messages",
  "show_ai_chats",
  "show_tasks",
];

/**
 * A feature is available unless its flag is explicitly `false`.
 *
 * The hand override in `shared/types/supabase.types.ts` narrows these columns
 * on the `projects` view to non-null `boolean` (matching the `containers`
 * table), and the DB default is `true`. The `!== false` check is intentionally
 * null-defensive anyway: it keeps the UI fail-open so a missing/unknown flag
 * (or a null project) never hides a feature.
 */
export function isProjectFeatureEnabled(
  project: Pick<Project, ProjectFeatureFlag> | null | undefined,
  flag: ProjectFeatureFlag,
): boolean {
  return project?.[flag] !== false;
}
